// src/services/patientProfileService.ts
import { AxiosResponse } from 'axios';
import api from './api';

export interface PatientProfile {
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  postalCode: string
  country: string
  data(data: any): unknown
  _id: string
  firstName: string
  lastName: string
  preferredName?: string
  email: string
  phone: string
  dateOfBirth?: Date | null | string
  dob?: string // 👈 Added this line
  gender?: string
  pronouns?: string
  profilePhotoUrl?: string
  therapyHistory?: string
  sessionFrequency?: string
  careGoal?: string
}

// export interface ProfileFormData {
//   // firstName: string;
//   // lastName: string;
//   // preferredName: string;
//   // email: string;
//   // phone: string;
//   // dateOfBirth: Date | null;
//   // gender: string;
//   // pronouns: string;
//   // address: {
//   //   street: string;
//   //   city: string;
//   //   state: string;
//   //   zipCode: string;
//   //   country: string;
//   // };

//   firstName: string,
//   lastName: string,
//   preferredName: string,
//   email: string,
//   phone: string,
//   dateOfBirth: Date | null | string;
//   gender: string,
//   pronouns: string,
//   addressLine1: string,
//   addressLine2: string,
//   city: string,
//   state: string,
//   postalCode: string,
//   country: string,
//   therapyHistory: false,
//   sessionFrequency: string,
//   careGoal: string,
// }

export interface PatientProfileResponse {
  message: string;
  data: PatientProfile;
}

export interface UploadPhotoResponse {
  message: string;
  data: {
    profilePhotoUrl: string;
  };
}

// Get patient profile details
export const getPatientProfile = async (): Promise<PatientProfile> => {
  const response: AxiosResponse<PatientProfileResponse> = await api.get(
    '/patient/profile'
  );
  return response.data.data;
};

// Update patient profile
export const updatePatientProfile = async (
  profileData: Partial<PatientProfile>
): Promise<PatientProfile> => {
  const response: AxiosResponse<PatientProfileResponse> = await api.patch(
    '/patient/profile',
    profileData
  );
  return response.data.data;
};

// Upload profile photo
export const uploadProfilePhoto = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await api.post(
    '/patient/profile/upload-photo',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  // ✅ Ensure consistent return structure
  if (response.status === 200 || response.status === 201) {
    // The API might return nested data, so extract cleanly
    const url =
      response.data?.profilePhotoUrl ||
      response.data?.data?.profilePhotoUrl ||
      response.data?.url ||
      response.data?.data?.url

    return { profilePhotoUrl: url }
  }

  throw new Error('Unexpected response from server')
}